export { default } from "./ButtonAsLink";
export type { ButtonAsLinkProps } from "./ButtonAsLink";
